import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MergeImagesListImageScreen from "./MergeImagesListImageScreen";

function MergeImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Merge Images & Tile Images" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/merge_images", title: "Combine Images Free" },
    data2: { link: "/merge_images", title: "Photo Merger Online" },
    data3: { link: "/merge_images", title: "Image Merger Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Merge images online easily. Combine multiple photos into one image quickly with our fast, secure, and user-friendly image merger tool."
      ></meta>
      <meta
        name="keywords"
        content="merge images, image merger, combine images, merge photos online, photo merger, combine photos, image combiner, online image merger, merge images online, photo combine tool, merge pictures, join images online, image stitching tool, merge images free, image editor online, photo merger online, tile images, image tiler, arrange images side by side online, print multiple images in a single sheet, image grid online, image grid maker,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <MergeImagesListImageScreen title={title}></MergeImagesListImageScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Merge Images website provides a simple, fast, and reliable way to combine multiple images into a single image file with perfect alignment and high quality. Designed for ease of use, this powerful tool allows users to merge photos horizontally or vertically, create image collages, and combine images for documents, presentations, or social media content. Whether you want to join screenshots, stitch photos, or combine product images, this platform works efficiently as a modern image merger for everyday needs. Users can access the tool online, making it a flexible photo merger online and merge photos online solution that works across devices without complex software installation. Supporting popular formats such as JPG, PNG, and WebP, the website ensures original image quality is preserved during merging. With an intuitive interface and fast processing, users can upload images, arrange order, set spacing, and download the merged image instantly. Ideal for students, designers, professionals, and content creators, this image merger helps save time and improve workflow efficiency. If you are looking for a reliable merge images tool, an easy to use photo merger online, or a high-quality merge photos online solution, this website offers efficient way to combine images effortlessly." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Merge",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Merge Images Tool"
            why_use={[
              {
                title: "Combine Multiple Images into One",
                description:
                  "Our merge images tool allows users to combine multiple photos into a single image file. Using this photo merger online or image merger makes it easy to join screenshots and photos.",
              },
              {
                title: "Save Time and Boost Productivity",
                description:
                  "Merge photos online tools combine images instantly without manual editing, helping students, professionals, and creators save time.",
              },
              {
                title: "Perfect for Documents and Presentations",
                description:
                  "Our merge images tool helps organize visuals by combining multiple images into one for reports, presentations, and PDFs.",
              },
              {
                title: "Easy Online Access Without Installation",
                description:
                  "With a photo merger online, users can merge images directly in the browser without installing any software.",
              },
              {
                title: "Preserve Original Image Quality",
                description:
                  "High-quality image merger tools maintain resolution and clarity while merging images for professional results.",
              },
              {
                title: "Useful for Social Media and Marketing",
                description:
                  "Merge photos online tools are widely used to create collages, banners, and marketing visuals for social media platforms.",
              },
              {
                title: "Flexible Layout and Merge Options",
                description:
                  "Our modern merge images tool supports vertical, horizontal, and custom layouts, giving users control over image arrangement.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Most image merger tools support JPG, PNG, WebP, and other popular formats for flexible image merging.",
              },
              {
                title: "Beginner-Friendly and Fast",
                description:
                  "Our photo merger online offers a simple interface that allows users to merge images quickly without design or technical skills.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default MergeImagesMain;
